import { Component, OnInit } from '@angular/core';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { SETTINGS_GROUPS } from './settings-menu.data';
import { SettingsGroup } from './settings-menu.model';
import { filterSettingsGroups } from './settings-filter.util';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
    public searchTerm = '';
    private allowedGroups: SettingsGroup[] = [];

    constructor(
        private topbarService: TopbarService,
        private loginService: LoginService,
    ) {}

    ngOnInit(): void {
        this.topbarService.setTitle('Configuración');
        this.allowedGroups = SETTINGS_GROUPS
            .map((group) => ({
                label: group.label,
                items: group.items.filter((item) => this.loginService.hasPermission(item.permission)),
            }))
            .filter((group) => group.items.length > 0);
    }

    get filteredGroups(): SettingsGroup[] {
        return filterSettingsGroups(this.allowedGroups, this.searchTerm);
    }
}
